module.exports = __webpack_public_path__ + "img/empty_comment.4987eced.png";